import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './logo.css';

const Logo = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`logo ${isDarkMode ? 'dark' : 'light'}`}>
      <svg 
        viewBox="0 0 24 24" 
        width="32" 
        height="32" 
        className="logo-icon"
      >
        <path 
          fill="currentColor" 
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z"
        />
        <path 
          fill="currentColor" 
          d="M10.5 8.5L12 7l1.5 1.5L12 10z"
        />
        <path 
          fill="currentColor" 
          d="M10.5 13.5L12 15l1.5-1.5L12 12z"
        />
      </svg>
      <div className="logo-text">
        <span className="logo-primary">Leather</span>
        <span className="logo-secondary">Categories</span>
      </div>
    </div>
  );
};

export default Logo;
